import React from 'react';
import MainContainer from '../components/MainContainer';
import { autoresend_start, autoresend_stop, autoresend_query } from '../cruds/restApi';
import { Helmet } from 'react-helmet';

async function handleStart(e) {
  const result = await autoresend_start();
  handleStatus();
  console.log(`Start: ${result}`);
} 

async function handleStatus(e) {
  const result = await autoresend_query();
  let x = document.getElementById("AutoSendStatus");
  if (result===true) {
    x.innerHTML = '<div style="height: 2em; width: 2em; background-color: green; border-radius: 50%;"></div>';
  } else {
    x.innerHTML = '<div style="height: 2em; width: 2em; background-color: red; border-radius: 50%;"></div>';
  }
} 

async function handleStop(e) {
  const result = await autoresend_stop();
  handleStatus();
  console.log(`Stop: ${result}`);
} 


const VeriskAutoSend = props => {
  const x = () => {handleStatus();}
  return (
    <MainContainer>
      <Helmet>
        <script>{x()}</script>
      </Helmet>
      <div>
        <div id="AutoSendStatus"></div>
      </div>
      <div style={{height:1 +'em'}}></div>
      <span>&nbsp;</span>
      <button onClick={handleStart}>Start</button>
      <span>&nbsp;</span>
      <button onClick={handleStop}>Stop</button>
    </MainContainer>
  );
};

export default VeriskAutoSend;



// WEBPACK FOOTER //
// ./src/main/pages/VeriskAutoSend.js